import { SETTINGS } from '../../config/settings';
import { existingServices } from './existingServices';

// TODO: temporary move of federated modules (posthumous-web pending)
const links = existingServices?.reduce(
  (map, service) => {
    map[service.title] = service.link;

    return map;
  },
  { home: SETTINGS.public.urlPosthumousWeb } as Record<string, string>,
);

export default function usePosthumousRoutes() {
  return links;
}
